import {Component, Inject, OnInit} from '@angular/core';
import {Localization} from "../../../../../common/enums/localization";
import {AssignBoardFilters} from "../assign-board-filters";
import {UntypedFormControl} from "@angular/forms";
import {EnumsService} from "../../../../../common/services/enums.service";
import {ActionType} from "../../../../../common/enums/enums";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-assign-board-filters',
    templateUrl: './assign-board-filters.component.html',
    styleUrls: ['./assign-board-filters.component.scss']
})
export class AssignBoardFiltersComponent implements OnInit {

    public readonly Localization = Localization;
    public readonly jobTypeField = new UntypedFormControl(this.filters.jobType);
    public readonly jobTypeOptions = this.enums.enumAsOptions(ActionType, 'ActionType');

    constructor(
        private readonly self: MatDialogRef<AssignBoardFiltersComponent, AssignBoardFilters>,
        @Inject(MAT_DIALOG_DATA)
        private readonly filters: AssignBoardFilters,
        private readonly enums: EnumsService,
    ) {
    }

    public ngOnInit(): void {
    }

    public cancel() {
        this.self.close();
    }

    public applyFilters() {
        this.filters.jobType = this.jobTypeField.value;
        this.self.close(this.filters);
    }
}
